module.exports = __webpack_public_path__ + "img/generate-eth-address.f59ee400.png";